'use strict';

/**
 * @ngdoc component
 * @name mx.agent:mxMultiSchemaLink
 * @module mx.agent
 * @description Displays several schema objects
 * @param {string} label@ - Optional. Label of the control.
 * @param {value} type= - Indicates what schema type used (class or type)
 */
angular.module('mx.SolutionBuilderAgent').component('mxMultiSchemaLink', {
	bindings: {
		label: '@',
		value: '<',
		hideOnEmptyValue: '@',
		reserveIconSpace: '@',
		labelPosition: '@',
		valueMinWidth: '@',
		labelMinWidth: '@',
		labelMaxWidth: '@',
		valueColor: '@',
		icon: '@',
		designerMode: '<?',
		type: '@',
	},
	controller: MxMultiSchemaLinkCtrl,
	controllerAs: 'vm',
	template: [
		'$attrs',
		function (tAttrs) {
			const optimizer = typeof tAttrs.designerMode !== 'undefined' && ('' + tAttrs.designerMode).toLowerCase() !== 'false' ? '' : '::';
			return `<mx-literal
							label="{{::vm.label}}"
							type="html"
							compile-html="true"
							value="${optimizer}vm.literalValue"
							icon="{{::vm.icon}}"
							hide-on-empty-value="{{::vm.hideOnEmptyValue}}"
							reserve-icon-space="{{::vm.reserveIconSpace}}"
							label-position="{{::vm.labelPosition}}"
							value-min-width="{{::vm.valueMinWidth}}"
							label-min-width="{{::vm.labelMinWidth}}"
							label-max-width="{{::vm.labelMaxWidth}}"
							value-color="{{::vm.valueColor}}"
							${typeof tAttrs.designerMode !== 'undefined' ? `designer-mode="${tAttrs.designerMode}" ` : ''}>
						</mx-literal>`;
		},
	],
});

MxMultiSchemaLinkCtrl.$inject = ['mx.SolutionBuilderAgent.DialogOpenerService', 'mx.SolutionBuilderAgent.SchemaService', '$element'];

function MxMultiSchemaLinkCtrl(dialogOpener, schemaService, $element) {
	const vm = this;
	let _value;

	vm.valueClick = valueClickHandler;

	vm.$onInit = function () {
		vm.objDetails = null;

		_value = vm.value;

		Object.defineProperty(vm, 'value', {
			get: function () {
				return _value;
			},
			set: setValue,
		});
		setValue(_value);
	};

	vm.$postLink = function () {
		$element.addClass('mx-literal');
	};

	function valueClickHandler(event, internalName, displayName, type) {
		const obj = {
			_id: internalName,
			_name: displayName,
			_type: type === 'class' ? 'service_6886d8dc-51f8-e611-9382-f079595b3ec7' : 'service_7b83787c-81f7-e611-9382-f079595b3ec7',
		};
		dialogOpener.openPreview(obj);
	}

	function setValue(value) {
		_value = value;

		if (_value && Array.isArray(_value)) {
			return vm.type === 'class'
				? schemaService.getClasses().then(function (classes) {
						vm.literalValue = getValue(classes);
				  })
				: schemaService.getTypes().then(function (types) {
						vm.literalValue = getValue(types);
				  });
		}

		return null;
	}

	function getValue(items) {
		let res = '';

		const itemInfos = items.filter(function (item) {
			return _value.some(function (id) {
				return id === item.Id;
			});
		});
		if (itemInfos.length > 0) {
			itemInfos.forEach(function (info) {
				if (res !== '') {
					res += ', ';
				}
				res += `<a
								class="literal-value"
								ng-click="$parent.vm.valueClick($event, '${info.InternalName}', '${info.DisplayName}', '${vm.type}')"
								ng-href="#"
								ng-style="::{color:valueColor,  minWidth:valueMinWidth}"
								##ngclass##
								tabindex="-1">${info.DisplayName}
							</a>`;
			});
		}

		return res;
	}
}
